"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalApi = void 0;
var runtime = __importStar(require("../runtime"));
var models_1 = require("../models");
/**
 *
 */
var GlobalApi = /** @class */ (function (_super) {
    __extends(GlobalApi, _super);
    function GlobalApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalApi.prototype.buildUrl = function (path, queryParameters) {
        var query = this.configuration.queryParamsStringify(queryParameters);
        return "".concat(this.configuration.basePath).concat(path).concat(query && "?".concat(query));
    };
    GlobalApi.prototype.getInternalCallInfoForCheckPhoneNumber = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/phonenumber/check"
        };
    };
    GlobalApi.prototype.getUrlForCheckPhoneNumberByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForCheckPhoneNumber(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * check and normalize a telephone number
     */
    GlobalApi.prototype.checkPhoneNumberRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForCheckPhoneNumber(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CheckPhoneNumberRequestPayloadToJSON)(requestParameters.checkPhoneNumberRequestPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CheckPhoneNumberResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * check and normalize a telephone number
     */
    GlobalApi.prototype.checkPhoneNumber = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkPhoneNumberRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GlobalApi.prototype.getInternalCallInfoForGetNavigation = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/navigation"
        };
    };
    GlobalApi.prototype.getUrlForGetNavigationByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetNavigation(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * get the full myaccount navigation for the current user
     */
    GlobalApi.prototype.getNavigationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetNavigation(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (requestParameters.ecMobile !== undefined && requestParameters.ecMobile !== null) {
                            headerParameters['ec-mobile'] = String(requestParameters.ecMobile);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.NavigationFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get the full myaccount navigation for the current user
     */
    GlobalApi.prototype.getNavigation = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getNavigationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GlobalApi.prototype.getInternalCallInfoForGetNavigationWithDepthLimit = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/navigation"
        };
    };
    GlobalApi.prototype.getUrlForGetNavigationWithDepthLimitByPOST = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetNavigationWithDepthLimit(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * get the myaccount navigation for the current user with a limit on tree depth
     */
    GlobalApi.prototype.getNavigationWithDepthLimitRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetNavigationWithDepthLimit(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (requestParameters.ecMobile !== undefined && requestParameters.ecMobile !== null) {
                            headerParameters['ec-mobile'] = String(requestParameters.ecMobile);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.NavigationDepthRequestPayloadToJSON)(requestParameters.navigationDepthRequestPayload),
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.NavigationFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get the myaccount navigation for the current user with a limit on tree depth
     */
    GlobalApi.prototype.getNavigationWithDepthLimit = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getNavigationWithDepthLimitRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GlobalApi.prototype.getInternalCallInfoForGetValidCountries = function (requestParameters) {
        var queryParameters = {};
        return {
            queryParameters: queryParameters,
            path: "/countries"
        };
    };
    GlobalApi.prototype.getUrlForGetValidCountriesByGET = function (requestParameters) {
        var _a = this.getInternalCallInfoForGetValidCountries(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
        return this.buildUrl(path, queryParameters);
    };
    /**
     * get a list of valid countries for the country selector
     */
    GlobalApi.prototype.getValidCountriesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, queryParameters, path, headerParameters, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.getInternalCallInfoForGetValidCountries(requestParameters), queryParameters = _a.queryParameters, path = _a.path;
                        headerParameters = {};
                        if (requestParameters.ecLocale !== undefined && requestParameters.ecLocale !== null) {
                            headerParameters['ec-locale'] = String(requestParameters.ecLocale);
                        }
                        if (!(this.configuration && this.configuration.apiKey)) return [3 /*break*/, 2];
                        _b = headerParameters;
                        _c = "x-ec-token";
                        return [4 /*yield*/, this.configuration.apiKey("x-ec-token")];
                    case 1:
                        _b[_c] = _d.sent(); // EmpirieComToken authentication
                        _d.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: path,
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        })];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ValidCountriesResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * get a list of valid countries for the country selector
     */
    GlobalApi.prototype.getValidCountries = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getValidCountriesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return GlobalApi;
}(runtime.BaseAPI));
exports.GlobalApi = GlobalApi;
//# sourceMappingURL=GlobalApi.js.map